import React from "react";
import Chart from "react-apexcharts";
import axios from "axios";
import { logout } from "./../../../utils/api";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "./FinancialCharts.scss";

class BudgetChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      series: [],
      options: {
        chart: {
          height: 330,
          type: "line",
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        colors: ["#666666"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },
        grid: {
          row: {
            colors: ["#fafafa", "transparent"],
            opacity: 0.5,
          },
        },

        yaxis: {
          labels: {
            formatter: function(value) {
              return value.toLocaleString();
            },
          },
        },
        xaxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
            "Jan",
          ],
        },
        annotations: {
          yaxis: [
            {
              y: 8800,
              borderColor: "#00E396",
              label: {
                borderColor: "#00E396",
                style: {
                  color: "#fff",
                  background: "#00E396",
                },
              },
            },
          ],
        },
      },
    };
  }

  componentDidMount() {
    axios
      .get("finances/get_data_chart2", {
        params: {
          token: this.props.token,
        },
      })
      .then((res) => {
        if (res?.data?.go_to_login === 1) {
          this.props.logout(this.props.token);
        } else {
          this.setState({ series: Array.isArray(res.data) ? res.data : [] });
        }
      })
      .catch((err) => console.log(err));
  }

  render() {
    return (
      <div className="col-lg-6 col-xxl-6">
        <div className="card card-custom">
          <div className="financial-chart-dashboard-container">
            <div className="financial-chart-title">Buget disponibil 2020</div>
            <div id="chart">
              <Chart
                options={this.state.options}
                series={this.state.series}
                type="line"
                height={330}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
    },
    dispatch
  );
}
export default connect(
  ({ layoutService, auth }) => ({
    languagePack: layoutService.languagePack,
    currentUser: auth.user,
    token: auth?.user?.token,
  }),
  mapDispatchToProps
)(BudgetChart);
